import { BreakWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Break')
export class BreakNodeSchemaProvider extends SchemaProvider<BreakWorkflowNode> {}
